import DashboardLogoRedeOkay from "./DashboardLogoRedeOkay";
import DelendDashboardLogo from "./DelendDashboardLogo";

const DashboardLogo = () => {
  const path = window.location.href;
  if (path.includes(".ok.")) {
    return <DashboardLogoRedeOkay></DashboardLogoRedeOkay>;
  }
  return <DelendDashboardLogo></DelendDashboardLogo>;
};

export default DashboardLogo;
